<template>
<div class="wl-mock-cerfity-select-wrapper">
    <div class="cerfity-select-main">
        <p class="p-cerfity-title">模拟练习证书类型选择</p>
        <div class="cerfity-list-con clearfix">
            <div class="fl cerfity-item-con" v-for="(item,index) in list" :key="index">
                <a :href="item.SimulateSystemUrl" target="_blank">
                    <div class="c-cover-con" :style="{backgroundImage:'url('+ item.CertificateCover +')'}"></div>
                    <div class="c-name-con">{{item.CertificateName}}</div>
                </a>
            </div>
            <!-- <div class="fl cerfity-item-con">
                <div class="c-cover-con" :style="{backgroundImage:'url('+ defaultCover +')'}"></div>
                <div class="c-name-con">物流中级证书模拟练习</div>
            </div>
            <div class="fl cerfity-item-con">
                <div class="c-cover-con" :style="{backgroundImage:'url('+ defaultCover +')'}"></div>
                <div class="c-name-con">物流高级证书模拟练习</div>
            </div> -->
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            defaultCover: require('assets/images/default-cerfity-img.jpg'),
            list:[]
        }
    },
    created(){
        this.getCertificateList();
    },
    methods:{
        getCertificateList(){
            var that = this;
            this.$http.post("/api/XOrg/CertificateGet/getCertificateList").then(function(rst) {
                if (rst.code > 0) {
                    that.list = rst.list;
                } else {
                    that.$message.warning(rst.msg);
                }
            });
        },
    }

}
</script>

<style lang="scss">
.wl-mock-cerfity-select-wrapper {
    margin-top: -20px;

    .cerfity-select-main {
        margin: 0 auto;
        width: 1200px;
    }

    .p-cerfity-title {
        font-size: 18px;
    }

    .cerfity-list-con {
        margin-top: 20px;
    }

    .cerfity-item-con {
        margin-right: 30px;
        padding: 15px;
        width: 270px;
        height: 210px;
        border: 1px solid #F4F7FA;
        background: #fff;

        .c-cover-con {
            height: 175px;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center top;
        }

        .c-name-con {
            padding-top: 15px;
            font-size: 16px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }
}
</style>
